import { create } from 'zustand'
import { User } from '../types'

interface State {
  user: User | undefined;
  hasSubscription?: boolean; // Optional, can be set later
  chartsCount: number
  incrementChartsCount: () => void
  decrementChartsCount: () => void
  setChartsCount: (count: number) => void
  setUser: (user: User | undefined) => void
}

export const useStore = create<State>()(
    (set) => ({
      user: undefined,
      chartsCount: 0,
      incrementChartsCount: () => set((state) => ({ chartsCount: state.chartsCount + 1 })),
      decrementChartsCount: () => set((state) => ({ chartsCount: state.chartsCount - 1 })),
      setChartsCount: (count: number) => set({ chartsCount: count }),
      setUser: (user: User | undefined) => set({ user }),
    }),
)